import styled from '@emotion/styled'
import { Link } from 'gatsby'

import { breakpoints } from '../../utils/styles'

export const Wrapper = styled.header`
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.05);
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  height: 100px;
  font-family: 'SohneBreit';
  font-weight: 400;
  letter-spacing: 1px;
  font-size: 16px;
  width: 100%;

  @media (max-width: ${breakpoints.s}px) {
    height: auto;
  }
`

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.45rem 2.5rem;
  margin: 0 auto;

  @media (max-width: ${breakpoints.s}px) {
    padding: 14px 20px;
  }
`

export const MenuLink = styled(Link)`
  color: currentColor;
  display: flex;
  align-items: center;
  text-decoration: none;

  @media (max-width: ${breakpoints.s}px) {
    font-size: 14px;
  }

  &:hover {
    span {
      text-decoration: underline;
    }
  }
`

export const CartCounter = styled.span`
  border-radius: 20px;
  background: #d16643;
  width: 30px;
  margin-left: 10px;
  font-family: 'SohneBreit';
  height: 30px;
  display: inline-flex;
  text-align: center;
  justify-content: center;
  color: white;
  font-size: 16px;
  line-height: 28px;
  z-index: 20;

  @media (max-width: ${breakpoints.s}px) {
    font-size: 14px;
    line-height: 26px;
    width: 28px;
    height: 28px;
  }
`

export const LogoWrapper = styled.div`
  width: 100%;
  margin: 0 auto;

  @media (max-width: ${breakpoints.s}px) {
    width: 90%;
  }
`

export const Nav = styled.nav`
  display: flex;

  ul {
    list-style: none;
    display: flex;
    padding: 0;
  }

  li {
    margin-right: 30px;
  }

  a {
    color: black;
    text-decoration: none;
  }

  @media (max-width: ${breakpoints.s}px) {
    li a {
      display: none;
    }
  }
`

export const MenuIconWrap = styled.div`
  padding: 10px;
  display: none;
  position: relative;
  z-index: 10;

  @media (max-width: ${breakpoints.s}px) {
    display: block;
  }
`

export const MenuIcon = styled.nav`
  width: 30px;
  height: 30px;
  position: relative;

  &:before,
  &:after {
    width: 100%;
    height: 2px;
    content: '';
    position: absolute;
    background: #215041;
  }

  &:before {
    top: 10px;
  }

  &:after {
    bottom: 10px;
  }
`

export const FloatingNav = styled.div`
  position: fixed;
  display: none;
  top: 106px;
  width: 100%;
  left: 0;
  background-color: #f4f4f4;
`

export const BannerWrapper = styled.div`
  position: absolute;
  z-index: 2;
  top: 100px;
  overflow: hidden;
  width: 100%;
  left: 0;

  @media (max-width: ${breakpoints.s}px) {
    top: 78px;
  }
`

export const Banner = styled.div`
  background: #ffcb2c;
  font-family: 'SohneBreit';
  font-weight: 400;
  color: #211f15;
  text-align: center;

  width: 100%;
  font-size: 12px;
  letter-spacing: 2px;
  line-height: 33px;

  .stars {
    margin: 0 10px;
    top: 0px;
    position: relative;
  }

  span {
    margin: 0 20px;
  }

  @media (max-width: ${breakpoints.s}px) {
    line-height: 30px;
    font-size: 10px;
  }
`

export const MobileMenu = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: white;
  transition: all 300ms cubic-bezier(0.215, 0.61, 0.355, 1);
  transform: translateY(-100%);

  .navigation {
    list-style: none;
    padding: 0;
    margin: 0 0 60px 0;
    text-align: center;

    li {
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .content {
    opacity: 0;
    transition: all 300ms ease-in-out;
    transition-delay: 300ms;
  }

  &.is-visible {
    transform: translateY(0);

    .content {
      opacity: 1;
    }
  }
`

export const MobileMenuLink = styled(Link)`
  font-size: 32px;
  color: currentColor;
  text-decoration: none;
`
